import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { DemandDelegate } from "./demand.delegate";
import { IDemand } from "./demand.interface";
import { IDemandResponse } from "./demand.interface";
import { IDemandRole } from '../DemandRoleService';

export class DemandService
{
    public demandsData: IDemand[] = null;
    private demandsubject: BehaviorSubject<IDemand[]> = new BehaviorSubject(null);
    public demands: Observable<IDemand[]> = this.demandsubject;

    private selectedDemandId: string = "0";


    constructor(private demandDelegate: DemandDelegate)
    {
    }

    public get demandId(): string
    {
        return this.selectedDemandId;
    }

    public setSelectedDemandId(demandId: string): void
    {
        this.selectedDemandId = demandId;
    }

    public getAllDemands(hardReload: boolean = false)
    {
        if (this.demandsData !== null && this.demandsData.length > 0 && hardReload === false)
        {
            return;
        }
        const response = this.demandDelegate.getAllDemands();
        return this.processDemands(response);
    }

    public getSelectedDemand(): IDemand
    {
        return this.demandsData.find(demand => demand.demandId === this.selectedDemandId);
    }

    public createNewDemand(demand: IDemand): Observable<boolean>
    {
        demand.clientTimeStamp = new Date().toISOString();
        const response = this.demandDelegate.createNewDemand(demand);
        return this.processDemands(response);
    }

    public updateDemand(demand: IDemand): Observable<boolean>
    {
        demand.demandId = this.selectedDemandId;

        demand.clientTimeStamp = new Date().toISOString();
        const response = this.demandDelegate.updateDemand(demand);
        return this.processDemands(response);
    }

    public createNewDemandRole(demandRole: IDemandRole): Observable<boolean>
    {
        demandRole.demandId = this.selectedDemandId;

        demandRole.clientTimeStamp = new Date().toISOString();
        const response = this.demandDelegate.createNewDemandRole(demandRole);
        return this.processDemands(response);
    }

    public updateDemandRole(demandRole: IDemandRole): Observable<boolean>
    {
        demandRole.clientTimeStamp = new Date().toISOString();
        const response = this.demandDelegate.updateDemandRole(demandRole);
        return this.processDemands(response);
    }

    private processDemands(demandResponse: Observable<IDemandResponse>): Observable<boolean>
    {
        demandResponse.subscribe(onSuccess.bind(this), onFault.bind(this));

        return demandResponse.pipe(mergeMap((response: IDemandResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(demandResponse: IDemandResponse)
        {
            if (demandResponse.success)
            {
                this.selectedDemandId = demandResponse.demandId ?
                    demandResponse.demandId :
                    this.selectedDemandId;
                if (demandResponse.demands.length > 0 || demandResponse.demands.length === 0)
                {
                    this.demandsData = demandResponse.demands;
                    this.demandsubject.next(this.demandsData);
                }
            }
        }

        function onFault(error: any)
        {
           // DemandService.logger.error(`processDemands Fault - Error (${JSON.stringify(error)})`);
        }
    }
}